import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
var App = /** @class */ (function (_super) {
    tslib_1.__extends(App, _super);
    function App() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    App = tslib_1.__decorate([
        Component({})
    ], App);
    return App;
}(Vue));
export default App;
